import { SecureClient } from '../../../utils';

const verifyOTPExistingCustomerAPICall = ({
  customerCredentials,
  payload,
  successFn,
  errorFn,
  finallyFn,
}) => {
  const { customerId, Authorization, customerRefNum } = customerCredentials;
  SecureClient({
    isEncrypted: true,
    customerId,
    otherPayloadDetailsPresent: true,
    route: 'esqa/verifyotpexistingcustomer',
    headers: {
      Authorization,
    },
    payload,
    successFn,
    errorFn,
    finallyFn,
  });
};

export default verifyOTPExistingCustomerAPICall;
